import { Component, OnInit } from '@angular/core';
import { HttpModule } from '@angular/http';
import { Validators, FormGroup, FormBuilder } from '@angular/forms';
import { Router, ActivatedRoute, Params } from '@angular/router';
import { FlashMessagesService } from 'angular2-flash-messages';

// Services
import { SegmentEditService } from '../../service/segment-edit/segment-edit.service';


@Component({
	selector: 'app-segment-edit',
	templateUrl: './segment-edit.component.html',
	providers: [
		SegmentEditService,
		HttpModule
	]
})
export class SegmentEditComponent implements OnInit {
	segmentUpdate: FormGroup;
	ID: string;
	Descricao: string = "";
	Ativo: boolean;
	private token;
	private sub: any;
	public permissoes: any[] = [];

	constructor(fb: FormBuilder, private segmentEditService: SegmentEditService, private flashMessagesService: FlashMessagesService, private router: Router, private route: ActivatedRoute) {
		this.token = localStorage.getItem('yara.token');
		this.segmentUpdate = fb.group({
			'ID': '',
			'Descricao': ['', Validators.compose([Validators.required, Validators.maxLength(120)])],
			'Ativo': ''
		});
	}

	ngOnInit() {
		this.permissoes = localStorage.getItem('yara.permissions') ? JSON.parse(localStorage.getItem('yara.permissions')) : [];
		this.sub = this.route.params.subscribe(params => {
			this.ID = params['guid'];
			this.segmentEditService.loadSegment(this.token, this.ID).subscribe(result => {
				var updatesegment = result.Result;
				this.segmentUpdate.setValue({
					ID: updatesegment.ID,
					Descricao: updatesegment.Descricao,
					Ativo: updatesegment.Ativo
				});
				this.ID = updatesegment.ID;
				this.Ativo = updatesegment.Ativo;
				this.Descricao = updatesegment.Descricao;
			}, error => {
				console.log(error);
				
			})
		});
	}

	editClientType(value: any) {
		this.segmentEditService.editSegment(this.token, value).subscribe(result => {
			if (result.Success) {
				this.flashMessagesService.show('Segmento editado com sucesso', { cssClass: 'alert-success', timeout: 6000 });
				this.router.navigateByUrl('/segmento');
			} else {
				this.flashMessagesService.show(result.Errors, { cssClass: 'alert-danger', timeout: 6000 });
			}
		}, error => {
			console.log(error);
			
		});
	}

	cancelInsertEdit() {
		this.router.navigateByUrl('/segmento');
	}

}



// WEBPACK FOOTER //
// ./src/app/segments/component/segment-edit/segment-edit.component.ts